
import { defineComponent, useStore, computed } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {},
  setup() {
    const isLoadingActive = computed(
      () => useStore().getters['loading/isLoadingActive']
    )

    return {
      isLoadingActive,
    }
  },
})
